import { useTranslation } from "react-i18next";
import Table from "../../components/table/table";
import BoxIcon from "../../icons/boxIcon";

const tableData = [
  {
    week: "0",
    trailA: "0.50",
    trailB: "0.50",
    trailC: "0.50",
  },
  {
    week: "1",
    trailA: "1.26",
    trailB: "1.01",
    trailC: "0.94",
  },
  {
    week: "2",
    trailA: "2.21",
    trailB: "1.48",
    trailC: "1.13",
  },
  {
    week: "3",
    trailA: "3.52",
    trailB: "2.03",
    trailC: "1.20",
  },
];
const Ft40 = () => {
  const { t } = useTranslation();
  const tableHead = [
    {
      header: t("week"),
      accessorKey: "week",
    },
    {
      header: t("trialA"),
      accessorKey: "trailA",
    },
    {
      header: t("trialB"),
      accessorKey: "trailB",
    },
    {
      header: t("trialC"),
      accessorKey: "trailC",
    },
  ];
  return (
    <section>
      <Table
        TableData={tableData}
        TableHead={tableHead}
        header={t("40FTContainer")}
        icon={<BoxIcon className="size-6" />}
      />
    </section>
  );
};

export default Ft40;
